if (!customElements.get("page-header-logo-banner-new")) {
    customElements.define(
      "page-header-logo-banner-new",
      class PageHeaderLogoBannerSection extends HTMLElement {
        constructor() {
        super();
        this.logoBanner = null;
        this.headerLogo = null;
        this.banner = this.querySelector('.wt-logo-banner__img-wrapper ');
        this.header = document.querySelector('.wt-header');
        this.handleScroll = this.handleScroll.bind(this);
      }

      connectedCallback() {
        this.setupHeaderMode();
        this.logoBanner = this.querySelector('.wt-logo-banner__logo');
        console.log(this.logoBanner);
        this.headerLogo = document.querySelector('.wt-header__logo')

        if (this.logoBanner) {
          window.addEventListener("scroll", this.handleScroll);
        }


        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (this.headerLogo) {
                if (entry.isIntersecting) {
                  this.headerLogo.style.opacity = "0";
                  this.headerLogo.style.transition = "opacity 0.3s ease";
                  this.header.classList.add("wt-header--transparent");
                } else {
                  this.headerLogo.style.opacity = "1";
                  this.header.classList.remove("wt-header--transparent");
                }
              }
            });
          },
          {
            threshold: 0,
          }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this.handleScroll.bind(this));
        if (this.observer) {
        this.observer.disconnect();
      }
      }

      setupHeaderMode() {
        const header = document.querySelector(".wt-header");
        const stickyHeaderThreshold = document.querySelector(
          ".sticky-header__threshold",
        );
        const isHeaderSticky =
          document.body.classList.contains("page-header-sticky");

        
          const isHeaderTransparent = header.classList.contains(
            "wt-header--transparent",
          );

          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = "120vh";
            // this.setTopMargin();
          }
         
      }

      handleScroll() {
        if (window.scrollY < 20) {
          this.logoBanner.style.opacity = "1";
        } else {
          this.logoBanner.style.opacity = "0";
        }
      }
      },
    );
  }
  